import {Box, getSize, VStack} from 'platform/foundation';

import {SkeletonLoadingBox} from '@dms/shared';

import {suffixTestId, type TestIdProps} from 'shared/web';

const TITLE_BAR_WIDTH = '75%';
const SUBTITLE_BAR_WIDTH = '50%';
const FOOTER_BAR_WIDTH = '33%';
const BAR_RADIUS = 'small';
const BAR_COLOR = 'palettes.neutral.40.100';

export function KanbanCardSkeleton(props: TestIdProps) {
  return (
    <Box
      borderRadius="medium"
      boxShadow="elevation_1"
      backgroundColor="palettes.white.10.100"
      borderLeft={`${getSize(1)} solid`}
      borderColor="palettes.neutral.40.100"
      padding={3}
      data-testid={suffixTestId('cardSkeleton', props)}
    >
      <VStack spacing={3}>
        <Box width={TITLE_BAR_WIDTH}>
          <SkeletonLoadingBox
            isLoading
            height={4}
            borderRadius={BAR_RADIUS}
            backgroundColor={BAR_COLOR}
          />
        </Box>
        <Box width={SUBTITLE_BAR_WIDTH}>
          <SkeletonLoadingBox
            isLoading
            height={3}
            borderRadius={BAR_RADIUS}
            backgroundColor={BAR_COLOR}
          />
        </Box>
        <Box width={FOOTER_BAR_WIDTH}>
          <SkeletonLoadingBox
            isLoading
            height={3}
            borderRadius={BAR_RADIUS}
            backgroundColor={BAR_COLOR}
          />
        </Box>
      </VStack>
    </Box>
  );
}
